import { Fail } from '../fails/fail';
import { UnauthorizedFail } from '../fails/unauthorized-fail';

export const isAuthRequired = (error: Fail) => error instanceof UnauthorizedFail;
